var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "FiltersContainer",
    { attrs: { title: "Filters" }, on: { click: _vm.handleReset } },
    [
      [
        _c(
          "FormGroup",
          { attrs: { title: "Company" } },
          [
            _c("CompaniesMultiselect", {
              attrs: { condition: _vm.companiesCondition },
              model: {
                value: _vm.companiesIds,
                callback: function ($$v) {
                  _vm.companiesIds = $$v
                },
                expression: "companiesIds",
              },
            }),
          ],
          1
        ),
        _c(
          "FormGroup",
          { attrs: { title: "Countries" } },
          [
            _c("ProfileCountrySelect", {
              attrs: { multiple: true },
              model: {
                value: _vm.countries,
                callback: function ($$v) {
                  _vm.countries = $$v
                },
                expression: "countries",
              },
            }),
          ],
          1
        ),
        _c("RegionInput", {
          attrs: { countries: _vm.countries, multiple: "" },
          model: {
            value: _vm.states,
            callback: function ($$v) {
              _vm.states = $$v
            },
            expression: "states",
          },
        }),
        _c(
          "FormGroup",
          { attrs: { title: "Cities" } },
          [
            _c("PostingCityMultiselect", {
              attrs: { country: _vm.countriesNames, state: _vm.statesNames },
              model: {
                value: _vm.cities,
                callback: function ($$v) {
                  _vm.cities = $$v
                },
                expression: "cities",
              },
            }),
          ],
          1
        ),
        _c(
          "FormGroup",
          { attrs: { title: "Employment type" } },
          [
            _c("EmploymentMultiselect", {
              attrs: { condition: _vm.postingsCondition },
              model: {
                value: _vm.employmentTypes,
                callback: function ($$v) {
                  _vm.employmentTypes = $$v
                },
                expression: "employmentTypes",
              },
            }),
          ],
          1
        ),
        _c(
          "FormGroup",
          { attrs: { title: "Skill" } },
          [
            _c("SkillsMultiselect", {
              model: {
                value: _vm.skillsIds,
                callback: function ($$v) {
                  _vm.skillsIds = $$v
                },
                expression: "skillsIds",
              },
            }),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }